export const isNonNullObject = (data: unknown): data is NonNullable<object> => typeof data === 'object' && data !== null
